module.exports = __webpack_public_path__ + "img/hermes_02.9e0b3e9e.jpg";